import { useCallback, useEffect } from 'react'

import { subscribe, unsubscribe } from '@arcotech-services/mfe-communicator'

import { Contracts } from '../../constants/contracts'
import { useSessionStore } from '../../stores/session'
import type {
  AuthData,
  BusinessUnit,
  UserInfo
} from '../../types/session.types'
import type { UseMfeReturn } from './use-mfe.types'

const useMfe = (): UseMfeReturn => {
  const isDataStored = useSessionStore(
    state => !!state.authData.accessToken && !!state.businessUnit.currentUnit.id
  )
  const setAuthData = useSessionStore(state => state.setAuthData)
  const setBusinessUnit = useSessionStore(state => state.setBusinessUnit)
  const setUserInfo = useSessionStore(state => state.setUserInfo)

  const handleAuthPublish = useCallback(
    (data: AuthData) => {
      setAuthData(data)
    },
    [setAuthData]
  )

  const handleBusinessUnitPublish = useCallback(
    (data: BusinessUnit) => {
      setBusinessUnit(data)
    },
    [setBusinessUnit]
  )

  const handleUserInfoPublish = useCallback(
    (data: UserInfo) => {
      setUserInfo(data)
    },
    [setUserInfo]
  )

  useEffect(() => {
    subscribe(Contracts.Auth, handleAuthPublish)
    subscribe(Contracts.BusinessUnits, handleBusinessUnitPublish)
    subscribe(Contracts.UserInfo, handleUserInfoPublish)

    return () => {
      unsubscribe(Contracts.Auth, handleAuthPublish)
      unsubscribe(Contracts.BusinessUnits, handleBusinessUnitPublish)
      unsubscribe(Contracts.UserInfo, handleUserInfoPublish)
    }
  }, [handleAuthPublish, handleBusinessUnitPublish, handleUserInfoPublish])

  return { isDataStored }
}

export default useMfe
